import React from "react";
import DetalleCard from "~business/Cards/DetalleCard";

import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import ColorLabelNegocio from "~styled/colorLabelNegocio/ColorLabelNegocio";
import { useSelector } from "react-redux";
import ItemInputCard from "~business/Cards/ItemInputCard";
import ItemDateCard from "~business/Cards/ItemDateCard";
import ItemCurrencyCard from "~business/Cards/ItemCurrencyCard";
import ItemCustomCard from "~business/Cards/ItemCustomCard";
import { formasPagoOptions, formasPagoFilter } from "~constants/formasPago";
import { companiasFilter, companiasSegurosOptions } from "~constants/companias";
import ItemSelectorCard from "~business/Cards/ItemSelectorCard";
import { OptionKV } from "~styled/selector/Selector";

const title = "Datos Generales";

interface DatosGeneralesCardProps {
  isLoading: boolean;
}

interface SliceDatosGenerales {
  negocio?: string;
  numeroPoliza?: string;
  compania?: string;
  coberturaSeleccionada?: string;
  premio?: number;
  vigenciaDesde?: string;
  formaPago?: string;
}

const useReduxSelector = () =>
  useSelector<any, SliceDatosGenerales>((state) => {
    const datosPlan = state.detallePolizaNuevoReducer.currentPoliza
      ? state.detallePolizaNuevoReducer.currentPoliza.datosPlan
      : {};
    const currentPoliza = state.detallePolizaNuevoReducer.currentPoliza;

    return {
      ...datosPlan,
      negocio: currentPoliza?.negocio,
      numeroPoliza: currentPoliza?.datosPlan.numeroPoliza,
      compania: datosPlan.compania,
      coberturaSeleccionada: currentPoliza?.coberturaId,
      premio: datosPlan.premioTotal,
      vigenciaDesde: datosPlan.polizaVigenciaDesde,
      formaPago: datosPlan.formaPago,
    };
  });

const DatosGeneralesCard: React.FC<DatosGeneralesCardProps> = ({
  isLoading,
}) => {
  const {
    negocio,
    compania,
    coberturaSeleccionada,
    premio,
    vigenciaDesde,
    formaPago,
    numeroPoliza,
  } = useReduxSelector();

  //TODO: abstraer componente mostrar tarjeta de credito
  return (
    <>
      <DetalleCard title={title} IconHeader={VerifiedUserIcon}>
        <ItemCustomCard isLoading={isLoading} label={"Negocio"}>
          <ColorLabelNegocio negocio={negocio ?? null} />
        </ItemCustomCard>
        <ItemInputCard
          isLoading={isLoading}
          label={"Número de Póliza"}
          value={numeroPoliza}
          readOnly
        />
        <ItemSelectorCard<string>
          isLoading={isLoading}
          label={"Compañía"}
          value={compania as string}
          options={companiasFilter as OptionKV<string>[]}
          valueOptions={companiasSegurosOptions}
          variant="big"
          readOnly
          required
        />
        <ItemInputCard
          isLoading={isLoading}
          label={"Cobertura Seleccionada"}
          value={coberturaSeleccionada}
          readOnly
        />
        <ItemCurrencyCard
          isLoading={isLoading}
          label={"Premio Total"}
          value={premio as unknown as string}
          readOnly
        />
        <ItemSelectorCard<string>
          isLoading={isLoading}
          label={"Forma de Pago"}
          options={formasPagoFilter as OptionKV<string>[]}
          valueOptions={formasPagoOptions}
          value={formaPago as string}
          variant="big"
          readOnly
          required
        />
        <ItemDateCard
          readOnly
          isLoading={isLoading}
          label={"Vigencia Desde"}
          value={vigenciaDesde}
        />
      </DetalleCard>
    </>
  );
};

export default DatosGeneralesCard;
